import actionBuilder, { update } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const bulkUpdateWeights = (payload, silent = false) => {
  const message = 'Custom field weights updated successfully.';
  return update(
    actionType,
    `${apiPath}/bulk/weights`,
    { data: payload, silent, message },
    false,
    true
  );
};

const actions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
  bulkUpdateWeights,
};

export default actions;
